import { BaseAPI } from './base';
import type { PaginationRequest } from '../../types/base.dto';

export interface Brand {
  id: string | number;
  sourceBrandId: string;
  name: string;
  englishName?: string;
  aliases?: string[] | string | null;
  status?: number;
  remark?: string;
  createdAt?: string;
  updatedAt?: string;
  [key: string]: any;
}

export interface BrandListParams extends PaginationRequest {
  sourceBrandId?: string;
  name?: string;
  status?: number;
}

export interface BrandCreateParams {
  sourceBrandId: string;
  name: string;
  englishName?: string;
  aliases?: string[];
  status?: number;
  remark?: string;
}

export interface BrandUpdateParams extends Partial<BrandCreateParams> {}

export class BrandAPI extends BaseAPI<Brand> {
  constructor() {
    super('/brands');
  }
}

export const brandApi = new BrandAPI();

export default brandApi;
